<div class="schedular-dialogue">
    <h1 mat-dialog-title>Set recurrence</h1>
    <div class="container">
        <div class="row">
            <div class="label-block">Repeat Every</div>
            <div class="calendar-block">
                <mat-form-field class="example-full-width">
                    <input matInput [(ngModel)]="repeatDay" placeholder="Number of days">
                </mat-form-field>
            </div>
            <div class="dropdown">
                <mat-form-field>
                    <mat-select [(ngModel)]="repeatValue" placeholder="Repeat after ">
                        <mat-option *ngFor="let option of repeatOptions" [value]="option.value">
                            {{ option.viewValue }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="label-block"></div>

            <div>
                <h4>
                    Occurs every {{repeatDay}} {{repeatValue ? repeatValue : 'Day'}}
                </h4>
            </div>
        </div>
        <div class="example-button-row">
            <button mat-raised-button class="cancel-button" (click)="onNoClick()">Cancel</button>
            <button mat-raised-button color="primary" (click)="onSave()">Save</button>
        </div>
    </div>
</div>